import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {
  pattern = new RegExp('^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$');


  constructor() { }

  RandomText(length: number) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$&*';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  GeneratePassword(length: number = 12): string {
    let generated: string;
    do {
      generated = this.RandomText(length);
    } while (!this.pattern.test(generated));
    return generated;
  }
}
